import React, { memo } from 'react';
import cls from './MonthModeHeader.module.css';
import classNames from 'classnames';
import moment from 'moment/moment';
import { addMoreMonths } from '../../../../../../helpers/getDays';
import { useInfiniteScrollNew } from 'shared/hooks/useInfinityScrollNew';
import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../../../../../store/reducers/gantSlice/gantSlice';

export const MonthModeHeader = memo(() => {
    const dispatch = useDispatch();

    const { months } = useSelector((state) => state.gantReducer);

    const last = months[months.length - 1];

    const onLoadNextPartLast = () => {
        if (last) {
            const current = last.title;
            const newMonths = addMoreMonths(`01.${current}`, 'last');
            dispatch(gantActions.setMonths([...months, ...newMonths]));
        }
    };
    const lastElementRef = useInfiniteScrollNew(onLoadNextPartLast);

    if (months.length === 0) return null;

    const lastMonth = last.title;
    const triggerLastMonth = moment(lastMonth, 'YYYY').subtract(1, 'years').format('YYYY');

    const nowDate = moment().format('DD.MM.YYYY');

    return (
        <div className={classNames(cls.DaysModeHeader)}>
            {months.map((year) => (
                <div className={classNames(cls.yearsWrapper)} key={year.title}>
                    <div className={classNames(cls.year)}>{year.title}</div>
                    <div className={classNames(cls.months)}>
                        {year.month.map((item) => (
                            <div
                                key={item.title + year.title}
                                className={classNames(cls.month)}
                                style={{ width: item.dayInMonth * 7 }}
                            >
                                <span className={cls.title}>{item.title}</span>
                                {item.days.map((day) => (
                                    <div
                                        data-date={moment(day.date, 'DD.MM.YYYY').format()}
                                        key={day.date}
                                        data-date-now={day.date === nowDate}
                                        style={{ width: 7 }}
                                        className={classNames({
                                            [cls.nowDate]: day.date === nowDate,
                                        })}
                                    />
                                ))}
                            </div>
                        ))}
                        {year.title === triggerLastMonth && <div ref={lastElementRef}></div>}
                    </div>
                </div>
            ))}
        </div>
    );
});
